export default "__VITE_ASSET__BCDX_lei__"